import Vue from 'vue'
import commonService from './common'
import kendo from "@progress/kendo-ui";

export default {
	displayMessage: "Your session is going to expire in 60 sec. Press Ok to logout and cancel to reset.",
	setCookies: function (guid) {
		//document.cookie = "_eremit_session_cookies_=" + guid + ";"
		if (location.hostname !== "localhost")
			//document.cookie = "_eremit_session_cookies_=" + guid + ";domain=." + location.host.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0] + ";path=/";
			document.cookie = "_eremit_session_cookies_=" + guid + ";domain=." + location.hostname.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0] + ";path=/; Secure; HttpOnly; SameSite=Strict.";
		else
			document.cookie = "_eremit_session_cookies_=" + guid + ";path=/;";
	},
	getCookies: function () {
		var name = "_eremit_session_cookies_=";
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	deleteCookies: function () {

	},
	resetSession: function () {
		var currentdate = new Date();
		var currentLoggedDate = currentdate.getFullYear() + "-" +
			(currentdate.getMonth() + 1) + "-" +
			currentdate.getDate() + " " +
			currentdate.getHours() + ":" +
			currentdate.getMinutes() +
			":" + currentdate.getSeconds();

		commonService.setStorage("loggedDateTime", currentLoggedDate.toString());

	},
	checkSession: function () {

		this.resetSession();

		if (window._sessionInterval != null) {
			clearInterval(window._sessionInterval)
		}
		window._sessionInterval = setInterval(() => {
			this.isAlive()
		}, 60000)
	},
	isAlive: function () {
		var self = this;
		var s = commonService.getStorage("loggedDateTime");
		var storeDate = new Date(s);
		var now = new Date();
		var diffMs = (now - storeDate);
		var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
		var idle = commonService.getStorage("EUIdleTime");
		var token = commonService.getStorage('token');
		console.log(parseInt(idle) - diffMins, '--')

		if ((!idle || parseInt(idle) <= 4)) {
			if (diffMins > 3) {
				clearInterval(window._sessionInterval);
				if (diffMins == 4) {
					var i = 60;
					var innerInterval = setInterval(() => {
						i--;
						document.querySelector(".k-dialog-content").innerHTML = "Your session is going to expire in " + i + " sec. Press Ok to logout and cancel to reset."

						if (i == 0) {
							clearInterval(innerInterval);
							document.querySelector(".k-dialog-buttongroup > .k-primary").click();
						}
					}, 1000)

					if (!!token) {
						kendo.confirm(self.displayMessage).then(function () {
							clearInterval(innerInterval);
							commonService.logOut();
						}, function () {
							clearInterval(innerInterval);
							self.checkSession();
						});
					} else {
						clearInterval(innerInterval);
					}
				} else
					commonService.logOut();
			}

		} else {


			if (parseInt(idle) - diffMins < 2) {
				console.log('222')
				clearInterval(window._sessionInterval);
				// var idle=commonService.getStorage("EUIdleTime");
				// var idleTime=4;
				// if(idle&&parseInt(idle)>0){
				// 	idleTime=parseInt(idle);
				// }
				if (parseInt(idle) - diffMins == 1) {
					console.log('111')
					var i = 60;
					var innerInterval = setInterval(() => {
						i--;
						document.querySelector(".k-dialog-content").innerHTML = "Your session is going to expire in " + i + " sec. Press Ok to logout and cancel to reset."

						if (i == 0) {
							clearInterval(innerInterval);
							document.querySelector(".k-dialog-buttongroup > .k-primary").click();
						}
					}, 1000)

					if (!!token) {
						kendo.confirm(self.displayMessage).then(function () {
							clearInterval(innerInterval);
							commonService.logOut();
						}, function () {
							clearInterval(innerInterval);
							self.checkSession();
						});
					} else {
						clearInterval(innerInterval);
					}
				} else
					commonService.logOut();
			}
		}

	},
	isAuthorized: function () {
		var isloggedin = commonService.getStorage('token') !== null;

		if (isloggedin) {

			// var session = this.getCookies();
			// if (session == null || session == '')
			// 	return false;
			this.checkSession();
		}
		return isloggedin;
	},
	isCompleteRegistration: function () {
		return commonService.getStorage('completeRegistration');
	},
	isPhoneNumberConfirmed: function () {
		return commonService.getStorage('phoneNumberConfirmed');
	},
	isforceChangePhoneNumber: function () {
		return commonService.getStorage('forceChangePhoneNumber');
	},
	isforceChangePassword: function () {
		return commonService.getStorage('forceChangePassword');
	},
	IsRequiredEkycBankDetail: function () {
		return commonService.getStorage('IsRequiredEkycBankDetail');
	},
	IsPassPhraseRequired: function () {
		return commonService.getStorage('IsPassPhraseRequired');
	},
	IsProfileUpdatedRequired: function () {
		return commonService.getStorage('IsProfileUpdatedRequired');
	},
	IsIdIssueDateUpdatedRequired: function () {
		return commonService.getStorage('IsIdIssueDateUpdatedRequired');
	},

	IsAddressDetailUpdated: function () {
		return commonService.getUserAddressValidation().IsValid;
	},
	checkAccessPath(to, from, next) {
		if (this.isAuthorized()) {
			//	debugger;
			if (this.isforceChangePassword() === 'true') {
				if (to.path != "/changepassword")
					return {
						path: '/changepassword'
					};
			} else if (this.IsPassPhraseRequired() == 'true') {
				if (to.path != "/updatepassphrase")
					return {
						path: '/updatepassphrase'
					};
			} else if (this.isforceChangePhoneNumber() === 'true') {
				if (to.path != "/changephone")
					return {
						path: '/changephone'
					};

			} else if (this.IsRequiredEkycBankDetail() == 'true') {
				if (to.path != "/ekyccustomerbankdetail") {
					return {
						path: '/ekyccustomerbankdetail'
					};
				}
			} else if (this.IsProfileUpdatedRequired() == 'true' || this.IsIdIssueDateUpdatedRequired() == 'true') {
				if (to.path != "/updatecustomer") {
					return {
						path: '/updatecustomer'
					};
				}
			} else if (this.isCompleteRegistration() === 'false') {
				if (this.isCompleteRegistration() === 'false' && !commonService.getStorage('IsCompleteForm')) {
					if (to.path != "/ekycdocument")
						return {
							path: '/ekycdocument'
						};
				} else if (this.isCompleteRegistration() === 'false') {
					if (to.path != "/registration/complete")
						return {
							path: '/registration/complete'
						};
				}

			} else if (!this.IsAddressDetailUpdated()) {
				if (to.path == '/dashboard' || to.path == '/profile') {
					next();
				} else {
					return {
						path: '/dashboard'
					}
				}
			}


		} else {
			return {
				path: '/account/login'
			};
		}
	},
	getToken: function () {
		return commonService.getStorage('token');
	},
	welcome: function () {
		window.Vue.$http.get('account/access').then(response => {}, response => {});
	},
	S4: function () {
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	},
	createGuid: function () {
		return (this.S4() + this.S4() + "-" + this.S4() + "-4" + this.S4().substr(0, 3) + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4()).toLowerCase();
	},


	signIn: function (username, password, passphrase, btnTrigger) {
		var self = this;
		var guid = self.createGuid();

		return window.Vue.$http.post('account/signin', {
			username: username,
			password: password,
			passphrase: passphrase,
			deviceidentifier: guid
		});

	},

	// signIn: function (username, password, passphrase, btnTrigger) {
	// 	var self = this;
	// 	var guid = self.createGuid();

	// 	window.Vue.$http.post('account/signin', {
	// 		username: username,
	// 		password: password,
	// 		passphrase: passphrase,
	// 		deviceIdentifier: guid
	// 	}).then(response => {
	// 		var result = response.body;



	// 		commonService.setStorage('token', result.DeviceKey);
	// 		commonService.setStorage('name', result.Name);
	// 		commonService.setStorage('refreshToken', result.RefreshToken);
	// 		commonService.setStorage('completeRegistration', result.CompleteRegistration.toString());
	// 		commonService.setStorage('phoneNumberConfirmed', result.PhoneNumberConfirmed.toString());
	// 		commonService.setStorage('countryFlag', result.CountryFlag);
	// 		commonService.setStorage('lastLoginDate', result.LastLogin);
	// 		commonService.setStorage('EUIdleTime', parseInt(result.EUIdleTime) - 1);
	// 		commonService.setStorage('userKycStatus', result.UserKycStatus);
	// 		commonService.setStorage('ekycEnable', result.EkycEnable.toString());
	// 		commonService.setStorage('ipAddress', result.IPAddress);
	// 		commonService.setStorage('emailAddressConfirmed', result.EmailAddressConfirmed.toString());
	// 		commonService.setStorage('isVerifiedEKYCUser', result.IsVerifiedEKYCUser.toString());
	// 		commonService.setStorage('isUnVerifiedKYCUser', result.IsUnVerifiedKYCUser.toString());
	// 		commonService.setStorage('forceChangePhoneNumber', result.ForceChangePhoneNumber.toString());
	// 		commonService.setStorage('forceChangePassword', result.ForceChangePassword.toString());
	// 		commonService.setStorage('IsRequiredEkycBankDetail', result.IsRequiredEkycBankDetail.toString());
	// 		commonService.setStorage('IsPassPhraseRequired', result.IsPassPhraseRequired.toString());
	// 		commonService.setStorage('IsProfileUpdatedRequired', result.IsProfileUpdatedRequired.toString());
	// 		commonService.setStorage('IsIdIssueDateUpdatedRequired', result.IsIdIssueDateUpdatedRequired.toString());
	// 		commonService.setStorage('IdDetail', result.IdDetail.toString());
	// 		commonService.setStorage('userDetail', JSON.stringify(result.UserDetail));
	// 		/*
	//   commonService.setStorage({
	// 	'token': result.DeviceKey,
	// 	'name': result.Name,
	// 	'refreshToken': result.RefreshToken,
	// 	'completeRegistration': result.CompleteRegistration,
	// 	'phoneNumberConfirmed': result.PhoneNumberConfirmed,
	// 	'countryFlag': result.CountryFlag,
	// 	'lastLoginDate': result.LastLogin,
	// 	'userKycStatus': result.UserKycStatus,
	// 	'ekycEnable': result.EkycEnable,
	// 	'ipAddress': result.IPAddress,
	// 	'emailAddressConfirmed': result.EmailAddressConfirmed,
	// 	'isVerifiedEKYCUser': result.IsVerifiedEKYCUser,
	// 	'isUnVerifiedKYCUser': result.IsUnVerifiedKYCUser,
	// 	'forceChangePhoneNumber': result.ForceChangePhoneNumber,
	// 	'forceChangePassword': result.ForceChangePassword,
	// 	'userDetail': JSON.stringify(result.UserDetail)
	//   });*/

	// 		if (result.Message !== "") {
	// 			kendo.confirm("Your session has already been started. Logged on IP:" + result.Message).then(function () {
	// 				window.Vue.$http.post("account/killsession");
	// 				self.setCookies(guid);
	// 				window.Vue.$router.push('/dashboard');
	// 				self.checkSession();
	// 			}, function () {
	// 				commonService.destroyStorage();
	// 			});
	// 		} else {
	// 			self.setCookies(guid);
	// 			window.Vue.$router.push('/dashboard');
	// 			self.checkSession();
	// 		}
	// 	}, response => {
	// 		var message = response.body === "" || response.body[0].Message === undefined ? "Internal Server Error." : response.body[0].Message;
	// 		return message;
	// 		//throw response;

	// 	});
	// },
	forgotPassword: function (username, dateOfBirth) {
		window.Vue.$http.post('account/forgotpassword', {
			username: username,
			DateOfBirth: dateOfBirth
		}).then(response => {
			window.Vue.$router.push("/account/confirmforgotpassword/" + response.body.OtpId);
		}, error => {

		});
	},
	mailValidate: function (user, code) {
		return window.Vue.$http.post("account/register/mailvalidation", {
			Key: user,
			Code: code
		});
	},
	emailUnsubscribe: function (userId) {
		return window.Vue.$http.post("account/unsubscribe", {
			UserId: userId
		});
	}

}
